export const MENU_LABELS = {
  copy: 'Make a copy',
  copyAsTemplate: 'Copy as template',
  remove: 'Remove project',
} as const
